export const translations = {
  // Header
  nav: {
    products: { tr: 'Çözümlerimiz', en: 'Solutions' },
    features: { tr: 'Neden Biz?', en: 'Why Us?' },
    howItWorks: { tr: 'Süreç', en: 'Process' },
    contact: { tr: 'İletişim', en: 'Contact' },
  },

  // Hero
  hero: {
    badge: { tr: 'Size Özel Yazılım', en: 'Custom Software For You' },
    title: { tr: 'İşletmenize Özel Yazılım Geliştiriyoruz', en: 'We Build Custom Software for Your Business' },
    subtitle: { 
      tr: 'Kurye yönetiminden veteriner takibine, e-ticaretten vardiya planlamasına — işletmenizin ihtiyacına özel yazılım çözümleri üretiyoruz.', 
      en: 'From courier management to veterinary tracking, from e-commerce to shift planning — we develop custom software solutions tailored to your business needs.' 
    },
    cta: { tr: 'Projenizi Konuşalım', en: 'Let\'s Discuss Your Project' },
    stats: {
      projects: { tr: 'Tamamlanan Proje', en: 'Completed Projects' },
      uptime: { tr: 'Sistem Kararlılığı', en: 'System Stability' },
      support: { tr: 'Destek', en: 'Support' },
    },
  },

  // Value Proposition
  value: {
    title: { tr: 'Neden Biz?', en: 'Why Us?' },
    subtitle: { 
      tr: 'Yazılım projelerinizde güvenilir çözüm ortağınız', 
      en: 'Your trusted partner for software projects' 
    },
    items: [
      {
        title: { tr: 'Size Özel Geliştirme', en: 'Custom Development' },
        description: { 
          tr: 'Hazır şablonlar değil, işletmenizin ihtiyaçlarına özel yazılım çözümleri üretiyoruz.', 
          en: 'We build custom software solutions tailored to your business needs, not off-the-shelf templates.' 
        },
      },
      {
        title: { tr: 'Uçtan Uca Çözüm', en: 'End-to-End Solutions' },
        description: { 
          tr: 'Analiz, tasarım, geliştirme, test ve deployment — tüm süreci yönetiyoruz.', 
          en: 'Analysis, design, development, testing and deployment — we manage the entire process.' 
        },
      },
      {
        title: { tr: 'Sürekli Destek', en: 'Ongoing Support' },
        description: { 
          tr: 'Proje tesliminden sonra da yanınızdayız. Bakım, güncelleme ve teknik destek sağlıyoruz.', 
          en: 'We\'re with you even after project delivery. We provide maintenance, updates and technical support.' 
        },
      },
      {
        title: { tr: 'Ölçeklenebilir Mimari', en: 'Scalable Architecture' },
        description: { 
          tr: 'İşletmeniz büyüdükçe yazılımınız da büyüsün. Geleceğe hazır altyapılar kuruyoruz.', 
          en: 'Your software grows as your business grows. We build future-ready infrastructures.' 
        },
      },
    ],
  },

  // Products (Portfolio)
  products: {
    title: { tr: 'Geliştirdiğimiz Çözümler', en: 'Solutions We Develop' },
    subtitle: { 
      tr: 'Farklı sektörlere özel yazılım projeleri geliştiriyoruz', 
      en: 'We develop custom software projects for different industries' 
    },
    items: [
      {
        name: 'AgrosJet',
        tagline: { tr: 'Kurye & Lojistik Yazılımları', en: 'Courier & Logistics Software' },
        description: { 
          tr: 'Kurye şirketleri için sipariş takibi, rota optimizasyonu ve filo yönetimi sistemleri geliştiriyoruz.', 
          en: 'We develop order tracking, route optimization and fleet management systems for courier companies.' 
        },
      },
      {
        name: 'AgrosVet',
        tagline: { tr: 'Veteriner Klinik Yazılımları', en: 'Veterinary Clinic Software' },
        description: { 
          tr: 'Veteriner klinikleri için hasta takibi, randevu yönetimi ve tedavi kayıt sistemleri oluşturuyoruz.', 
          en: 'We create patient tracking, appointment management and treatment record systems for veterinary clinics.' 
        },
      },
      {
        name: 'AgrosPet',
        tagline: { tr: 'E-Ticaret & CRM Sistemleri', en: 'E-Commerce & CRM Systems' },
        description: { 
          tr: 'Petshoplar ve perakende işletmeler için e-ticaret altyapısı ve müşteri yönetim sistemleri kuruyoruz.', 
          en: 'We build e-commerce infrastructure and customer management systems for pet shops and retail businesses.' 
        },
      },
      {
        name: 'ShiftJet',
        tagline: { tr: 'İK & Operasyon Yazılımları', en: 'HR & Operations Software' },
        description: { 
          tr: 'Vardiya planlama, personel yönetimi ve ön muhasebe sistemleri tasarlıyoruz.', 
          en: 'We design shift planning, personnel management and pre-accounting systems.' 
        },
      },
    ],
  },

  // How It Works
  howItWorks: {
    title: { tr: 'Nasıl Çalışıyoruz?', en: 'How We Work?' },
    subtitle: { 
      tr: 'Projenizi hayata geçirme sürecimiz', 
      en: 'Our process to bring your project to life' 
    },
    steps: [
      {
        title: { tr: 'Analiz & Planlama', en: 'Analysis & Planning' },
        description: { 
          tr: 'İhtiyaçlarınızı dinliyor, iş süreçlerinizi analiz ediyor ve size özel bir yol haritası çiziyoruz.', 
          en: 'We listen to your needs, analyze your business processes and create a custom roadmap for you.' 
        },
      },
      {
        title: { tr: 'Tasarım & Geliştirme', en: 'Design & Development' },
        description: { 
          tr: 'Modern teknolojilerle, kullanıcı deneyimini ön planda tutarak yazılımınızı geliştiriyoruz.', 
          en: 'We develop your software with modern technologies, prioritizing user experience.' 
        },
      },
      {
        title: { tr: 'Test & Teslim', en: 'Test & Delivery' },
        description: { 
          tr: 'Kapsamlı testlerden geçen yazılımınızı teslim ediyor, eğitim ve destek sağlıyoruz.', 
          en: 'We deliver your software after comprehensive testing, providing training and support.' 
        },
      },
    ],
  },

  // Features
  features: {
    title: { tr: 'Teknoloji & Kalite', en: 'Technology & Quality' },
    subtitle: { 
      tr: 'Projelerinizde kullandığımız yaklaşımlar', 
      en: 'Our approach in your projects' 
    },
    items: [
      {
        title: { tr: 'Modern Teknolojiler', en: 'Modern Technologies' },
        description: { 
          tr: 'React, Node.js, Python, Flutter — güncel ve güvenilir teknolojiler kullanıyoruz.', 
          en: 'React, Node.js, Python, Flutter — we use up-to-date and reliable technologies.' 
        },
      },
      {
        title: { tr: 'Mobil Uyumlu', en: 'Mobile Compatible' },
        description: { 
          tr: 'Web, iOS ve Android — tüm platformlarda çalışan çözümler üretiyoruz.', 
          en: 'Web, iOS and Android — we create solutions that work on all platforms.' 
        },
      },
      {
        title: { tr: 'Güvenli Altyapı', en: 'Secure Infrastructure' },
        description: { 
          tr: 'Verileriniz güvende. Güvenlik standartlarına uygun sistemler geliştiriyoruz.', 
          en: 'Your data is safe. We develop systems compliant with security standards.' 
        },
      },
      {
        title: { tr: 'Hızlı İletişim', en: 'Fast Communication' },
        description: { 
          tr: 'Proje sürecinde şeffaf iletişim. Sorularınıza hızlı yanıt veriyoruz.', 
          en: 'Transparent communication during the project. We respond quickly to your questions.' 
        },
      },
    ],
  },

  // CTA
  cta: {
    title: { tr: 'Projenizi Hayata Geçirelim', en: 'Let\'s Bring Your Project to Life' },
    subtitle: { 
      tr: 'Yazılım ihtiyacınızı anlatalım, size özel çözüm önerimizi sunalım.', 
      en: 'Tell us about your software needs, let us present our custom solution proposal.' 
    },
    button: { tr: 'Ücretsiz Danışmanlık Al', en: 'Get Free Consultation' },
  },

  // Contact Form
  contact: {
    title: { tr: 'İletişim', en: 'Contact' },
    subtitle: { 
      tr: 'Projeniz hakkında konuşalım', 
      en: 'Let\'s talk about your project' 
    },
    name: { tr: 'Ad Soyad', en: 'Full Name' },
    email: { tr: 'E-posta', en: 'Email' },
    message: { tr: 'Projenizi Anlatın', en: 'Describe Your Project' },
    namePlaceholder: { tr: 'Adınızı girin', en: 'Enter your name' },
    emailPlaceholder: { tr: 'E-posta adresinizi girin', en: 'Enter your email' },
    messagePlaceholder: { tr: 'Projeniz hakkında kısaca bilgi verin...', en: 'Tell us briefly about your project...' },
    submit: { tr: 'Gönder', en: 'Send' },
    success: { tr: 'Mesajınız alındı! En kısa sürede dönüş yapacağız.', en: 'Message received! We\'ll get back to you soon.' },
  },

  // Footer
  footer: {
    description: { 
      tr: 'AgrosTech, işletmelere özel yazılım çözümleri geliştiren bir yazılım şirketidir.', 
      en: 'AgrosTech is a software company that develops custom software solutions for businesses.' 
    },
    theme: { tr: 'Tema', en: 'Theme' },
    light: { tr: 'Açık', en: 'Light' },
    dark: { tr: 'Koyu', en: 'Dark' },
    language: { tr: 'Dil', en: 'Language' },
    rights: { tr: 'Tüm hakları saklıdır.', en: 'All rights reserved.' },
  },

  // App Stores Section
  appStores: {
    badge: { tr: 'Mobil Geliştirme', en: 'Mobile Development' },
    title: { tr: 'Mobil Uygulama Geliştiriyoruz', en: 'We Develop Mobile Apps' },
    subtitle: { 
      tr: 'İşletmeniz için iOS ve Android uygulamaları geliştiriyor, Google Play ve App Store\'da yayınlanmaya hazır hale getiriyoruz.', 
      en: 'We develop iOS and Android applications for your business, ready to be published on Google Play and App Store.' 
    },
    features: {
      tr: [
        'iOS & Android native geliştirme',
        'Anlık bildirim sistemleri',
        'Offline çalışma desteği',
        'Güvenli veri senkronizasyonu'
      ],
      en: [
        'iOS & Android native development',
        'Push notification systems',
        'Offline support',
        'Secure data synchronization'
      ]
    },
    cta: { tr: 'Mobil Projenizi Konuşalım', en: 'Let\'s Discuss Your Mobile Project' },
  },
};
